import "./styles.css";

export default function CheckBox({
  text,
  margin = "",
  isChecked = false,
  onChange = () => {},
}) {
  return (
    <div className="checkBoxContainer" style={{ margin: margin }}>
      <div
        className={`checkBoxBox ${isChecked ? "checkBoxBoxChecked" : ""}`}
        onClick={() => onChange()}
      />
      <div className="checkBoxText">{text}</div>
    </div>
  );
}
